import React from 'react'
import { Container, Row, Col } from 'react-awesome-styled-grid'

import Badge from '../components/Badge'
import Button from '../components/Button'
import Color from '../components/Color'
import { Section, SectionHeading, SectionContent } from '../components/Section'
import Text from '../components/Text'
import Title from '../components/Title'
// import { ModalContext } from '../hooks'

const Ebook = () => {
  // const { setModalState } = useContext(ModalContext)

  return (
    <Section
      id="ebook"
      className="duo-section-right texture-light"
      paddingTop="40"
      paddingBottom="40"
      fluid
    >
      <Container>
        <Row align="center" justify={{ xs: 'center', sm: 'space-between' }}>
          <Col
            xs={10}
            sm={5}
            data-sal="slide-right"
            data-sal-delay="300"
            data-sal-easing="ease"
            data-sal-duration="800"
          >
            <SectionHeading paddingTop={100} marginBottom={40}>
              <Badge label="E mais:" marginBottom={16} />
              <Title color="primary" appearance="section">
                Ao adquirir
                <br /> o curso, você
                <br /> ganha 2 ebooks
                <br /> do <i>Chef</i> Onildo.
              </Title>
            </SectionHeading>
            <SectionContent paddingBottom={100}>
              <Text
                marginTop={16}
                marginBottom={16}
                appearance="info"
                color="primary"
              >
                Em 10x nos cartões
              </Text>

              <Button
                target="_blank"
                href="https://pay.hotmart.com/N37277066I?checkoutMode=0&bid=1593475180852"
                title="Quero comprar"
                color="primary"
                fluid
                xl
              >
                Quero comprar
              </Button>

              <Text
                marginTop={16}
                marginBottom={16}
                size={12}
                color="dark"
                appearance="tag"
                className="t-center"
              >
                Módulo Milho + Módulo Macaxeira
              </Text>
            </SectionContent>
          </Col>
          <Col
            xs={10}
            sm={5}
            data-sal="slide-left"
            data-sal-delay="300"
            data-sal-easing="ease"
            data-sal-duration="800"
          >
            <SectionHeading paddingTop={100} marginBottom={40}>
              <Badge
                label="E-book*"
                marginBottom={16}
                color="light"
                appearance="ghost"
              />
              <Title color="light" appearance="hero-tiny">
                mousseline de macaxeira
              </Title>
              <Text color="light" className="t-lowercase">
                <i>Uma receita clássica, utilizandoum ingrediente nosso.</i>
              </Text>
            </SectionHeading>
            <SectionContent paddingBottom={100}>
              <Badge
                label="E-book*"
                marginBottom={16}
                color="light"
                appearance="ghost"
              />
              <Title color="light" appearance="hero-tiny">
                rôti de rapadurado <i>Chef</i> Onildo
              </Title>
              <Text color="light" className="t-lowercase">
                <i>Aprenda o rôti com um toque do nordeste.</i>
              </Text>

              <Text color="light" size={10} marginTop={32} appearance="tag">
                <i>
                  *Ao comprar os módulos Milho e Macaxeira juntos, você receberá
                  os 2 E-BOOKS no e-mail cadastrado.
                </i>
              </Text>
            </SectionContent>
          </Col>
        </Row>
      </Container>
    </Section>
  )
}

export default Ebook
